import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Typography,
} from '@mui/material';

import { useLocation, useNavigate } from 'react-router-dom';

import { ScreenBackV2WithTitle } from '../../../Components/ScreenBackV2';
import OnboardingContainer from '../../Component/OnboardingContainer';
import {
  addManufacturerRoleToExistingFirmAction,
  getCompanyAndRoleAction,
  getpricingGeographyAction,
} from '../../auth/action';
import NoData from '../../Component/noData';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CompanyAndRoleSelect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { firmGstPanDetails, editingIndustry, addingDealershipFromProfile } =
    useSelector((state) => state.firmOnbaordingReducer);
  const isEditingIndustry = Object.keys(editingIndustry).length > 0;
  const isAddingIndustryFromProfile =
    Object.keys(addingDealershipFromProfile).length > 0;

  const selectedIndustry = location.state?.industry || null;
  const selectedSubIndustry = location.state?.subIndustry || null;
  const [CompanyRoleData, setCompanyRoleData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(
    isEditingIndustry ? editingIndustry.roles : {},
  );
  const [selectedCompanyData, setSelectedCompanyData] = useState({});
  const [selectedCompanyRole, setSelectedCompanyRole] = useState(
    isEditingIndustry ? editingIndustry.roles : {},
  );
  const [pricingGeographyList, setPricingGeographyList] = useState([]);
  const [selectedPricingGeography, setSelectedPricingGeography] =
    useState(null);
  const getGeographyPricing = async (company_id) => {
    const district = isEditingIndustry
      ? editingIndustry.district_id
      : isAddingIndustryFromProfile
      ? addingDealershipFromProfile.district_id
      : firmGstPanDetails.district_id;

    const params = new URLSearchParams();
    params.append('district_id', district);
    params.append('manufacturer_id', company_id);

    const { data, error, message } = await getpricingGeographyAction(params);

    if (!error) {
      setPricingGeographyList(
        data.map((vv) => ({
          label: vv.pricing_geography_name,
          value: vv.pricing_geography_id,
        })),
      );
    } else return toast.error(message);
  };
  const handleRoleChange = (event) => {
    const selectedOptionData = selectedCompanyData?.roles.find(
      (option) => option.region_role_id == event.target.value,
    );
    const co_id = selectedCompanyData.manufacturer_id;
    const obj = {
      manufacturer_id: selectedCompanyData.manufacturer_id,
      manufacturer_name: selectedCompanyData.manufacturer_name,
      region_role_id: selectedOptionData.region_role_id,
      role_name: selectedOptionData.display_name,
      firm_role_id: selectedOptionData.firm_role_id,
      pricing_geography_id: selectedPricingGeography,
    };

    if (Object.keys(selectedCompanyRole).length === 0) {
      const temp = {
        [co_id]: obj,
      };
      setSelectedCompanyRole(temp);
    } else {
      let temp = { ...selectedCompanyRole };
      temp[co_id] = obj;
      setSelectedCompanyRole(temp);
    }
  };

  const onFinish = async () => {
    if (Object.keys(selectedCompanyRole).length === 0)
      return toast.error('Please select a role');

    if (isAddingIndustryFromProfile) {
      const temp = selectedCompanyRole[Object.keys(selectedCompanyRole)[0]];
      const payload = {
        manufacturer_id: temp.manufacturer_id,
        region_role_map_id: temp.region_role_id,
        company_id: addingDealershipFromProfile.company_id,
        firm_role_id: temp.firm_role_id,
        pricing_geography_id: temp.pricing_geography_id,
      };

      if (!payload?.pricing_geography_id)
        return toast.error(
          `Please select pricing geography for manufacturer -  ${temp.manufacturer_name}`,
        );

      const { error, message } = await addManufacturerRoleToExistingFirmAction(
        payload,
      );

      if (!error) {
        toast.success('Firm added successfully');

        dispatch({
          type: 'RESET_FIRM_ONBOARDING_REDUCER',
        });

        navigate('/my-account/firm-details');
      } else {
        toast.error(message);
      }
    } else {
      for (const item of Object.values(selectedCompanyRole)) {
        if (item.pricing_geography_id === null) {
          toast.error(
            `Please select pricing geography for manufacturer -  ${item.manufacturer_name}`,
          );
          return;
        }
      }

      let payload = {
        ...(isEditingIndustry ? editingIndustry : firmGstPanDetails),
        selectedIndustry: selectedIndustry,
        selectedSubIndustry: selectedSubIndustry,
        roles: selectedCompanyRole,
      };

      dispatch({
        type: 'ADD_FIRM',
        data: payload,
      });
      navigate('/FirmOnboardingSummary');
    }
  };

  const getRoles = async () => {
    const payload = {
      district_id: isEditingIndustry
        ? editingIndustry.district_id
        : isAddingIndustryFromProfile
        ? addingDealershipFromProfile.district_id
        : firmGstPanDetails.district_id,
      primary_industry_type: selectedIndustry.id,
      secondary_industry_type: selectedSubIndustry.id,
    };

    const { data, error, message } = await getCompanyAndRoleAction(payload);

    if (!error) {
      setCompanyRoleData(data);
      if (data.length > 0) setSelectedCompany(data[0].manufacturer_id);
      if (data.length > 0) setSelectedCompanyData(data[0]);
      if (data.length > 0) getGeographyPricing(data[0].manufacturer_id);
    } else {
      return toast.error(message);
    }
  };

  useEffect(() => {
    getRoles();
  }, []);
  useEffect(() => {
    if (pricingGeographyList?.length === 1) {
      setSelectedPricingGeography(pricingGeographyList[0]?.value);
    }
  }, [pricingGeographyList]);

  const handleOnCompanyClick = (company) => {
    setSelectedCompany(company.manufacturer_id);
    setSelectedCompanyData(company);
    setSelectedPricingGeography(null);
    setPricingGeographyList([]);
    getGeographyPricing(company.manufacturer_id);
  };

  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle title={'Select Company and Role'} />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            // mt: '2rem',
            // height: window.innerHeight * 0.5,
            // overflowY: 'auto',
          }}
        >
          {CompanyRoleData.length > 0 ? (
            <Grid
              container
              spacing={2}
              mt={2}
              sx={{ mb: '3rem' }}
            >
              <Grid
                item
                xs={5}
              >
                {CompanyRoleData.map((company) => (
                  <Box
                    key={company.manufacturer_id}
                    onClick={() => handleOnCompanyClick(company)}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      borderRadius: '5px',
                      my: '1rem',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      },
                      padding: '5px 10px',
                    }}
                  >
                    <Typography
                      variant='subtitle1'
                      color={
                        selectedCompany === company.manufacturer_id
                          ? 'primary'
                          : 'white'
                      }
                      fontSize={'1rem'}
                    >
                      {company.manufacturer_name}
                    </Typography>
                  </Box>
                ))}
              </Grid>
              <Grid
                item
                xs={7}
              >
                <Stack
                  spacing={1}
                  direction={'column'}
                  sx={{ padding: '5px' }}
                >
                  <Typography
                    variant='h5'
                    color={'white'}
                    fontSize={'1.125rem'}
                    style={{ marginTop: 16, fontWeight: 600 }}
                  >
                    Select Role for {''}
                    {selectedCompanyData?.manufacturer_name}
                  </Typography>
                  <FormControl component='fieldset'>
                    <RadioGroup
                      aria-label='role'
                      name='role'
                      onChange={handleRoleChange}
                    >
                      {selectedCompanyData &&
                        selectedCompanyData?.roles &&
                        selectedCompanyData?.roles.length > 0 &&
                        selectedCompanyData?.roles.map((role) => (
                          <FormControlLabel
                            key={role.region_role_id}
                            value={role.region_role_id}
                            control={
                              <Radio
                                sx={{
                                  color: 'white',
                                  '&.Mui-checked': { color: '#F49D3f' },
                                }}
                                checked={
                                  Object.keys(selectedCompanyRole).length > 0 &&
                                  selectedCompanyRole[
                                    selectedCompanyData?.manufacturer_id
                                  ]?.region_role_id === role.region_role_id
                                }
                              />
                            }
                            label={role.display_name}
                            sx={{
                              color: 'white',
                            }}
                          />
                        ))}
                    </RadioGroup>
                  </FormControl>
                  <Stack spacing={1}>
                    <Typography
                      variant='h5'
                      color={'white'}
                      fontSize={'1.125rem'}
                      style={{
                        marginTop: 20,
                        marginBottom: 4,
                        fontWeight: 600,
                      }}
                    >
                      Select Pricing Cluster for {''}
                      {selectedCompanyData?.manufacturer_name}
                    </Typography>
                    <FormControl sx={{ width: '60%' }}>
                      {pricingGeographyList?.length !== 1 && (
                        <InputLabel
                          sx={{
                            color: 'white',
                            '&.Mui-focused': {
                              color: 'white',
                            },
                          }}
                          id='pricingGeo'
                        >
                          Pricing Geography
                        </InputLabel>
                      )}
                      <Select
                        disabled={pricingGeographyList?.length === 1}
                        label='Pricing Geography'
                        onChange={(e) => {
                          if (
                            Object.keys(selectedCompanyRole).includes(
                              String(selectedCompany),
                            )
                          ) {
                            let tempObj = selectedCompanyRole[selectedCompany];
                            let temp = { ...selectedCompanyRole };

                            temp[selectedCompany] = {
                              ...tempObj,
                              pricing_geography_id: e.target.value,
                            };
                            setSelectedCompanyRole(temp);
                            setSelectedPricingGeography(e.target.value);
                          } else {
                            return toast.error('Please select a role first');
                          }
                        }}
                        value={selectedPricingGeography}
                        sx={{
                          color: 'white',
                          '.MuiOutlinedInput-notchedOutline': {
                            borderColor: 'white',
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'white',
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'white',
                          },
                          '.MuiSvgIcon-root': {
                            color: 'white',
                          },
                          '.MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled':
                            {
                              opacity: 1,
                              color: '#999999',
                              '-webkit-text-fill-color': 'unset',
                            },
                          '&.Mui-disabled': {
                            color: '#999999',
                            '.MuiOutlinedInput-notchedOutline': {
                              borderColor: '#999999',
                            },
                            '.MuiSvgIcon-root': {
                              color: '#999999',
                            },
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              bgcolor: 'white',
                              '& .MuiMenuItem-root': {
                                padding: '10px',
                                '&:hover': {
                                  backgroundColor: 'transparent',
                                },
                              },
                            },
                          },
                        }}
                      >
                        {pricingGeographyList.map((geo) => (
                          <MenuItem value={geo.value}>{geo.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          ) : (
            <Box sx={{ width: '80%' }}>
              <NoData text='No Industry is live for selected district' />
            </Box>
          )}
          {CompanyRoleData.length == 0 ? (
            <Button
              variant='contained'
              color='primary'
              sx={{ width: '80%' }}
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          ) : (
            <Button
              variant='contained'
              color='primary'
              sx={{ width: '80%', marginBottom: '2rem' }}
              onClick={onFinish}
            >
              {isAddingIndustryFromProfile ? 'Add Industry' : 'Continue'}
            </Button>
          )}
        </Box>
      </Box>
    </OnboardingContainer>
  );
};

export default CompanyAndRoleSelect;
